<template>
	<div class="manga-collection">
		<div class="container">
			<div v-if="title" class="row">
				<div class="col-12">
					<h2 class="float-left"> {{ title }}</h2>
				</div>
			</div>
			<div class="row justify-content-center">
				<div class="col-md-10 col-lg-12 col-xl-12 col-12" :class="horizontal ? 'scroll-horizontal' : 'scroll-vertical'" >
					<div class="card col-4 col-md-3 col-xl-3" v-for="manga in mangas" :key="manga.id">
						<router-link :to="{ name: 'Detail', params: { source: getURLString(), id: buildDetailUrl(manga) }}">
							<p class="complete" v-if="manga.completed">Complete</p>
							<img alt="thumbnail" :data-url="manga.thumbnail" v-observe-visibility="{ callback: visibilityChanged, once: true }"/>
							<div class="mar-top-1 font-size-1">
								<font-awesome-icon class="red mar-horizontal-1" icon="heart" />
								<span>{{ roundedWithAbbreviations(manga.favorites) }}</span>
								<font-awesome-icon class="mar-horizontal-1" icon="eye" />
								<span>{{ roundedWithAbbreviations(manga.views) }}</span>
							</div>
							<h3>{{ manga.title }}</h3>
						</router-link>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { ObserveVisibility } from "vue-observe-visibility";

export default {
	directives: {
		ObserveVisibility
	},
	props: {
		title: String,
		mangas: Array,
		horizontal: Boolean
	},
	methods: {
		roundedWithAbbreviations(number) {
			let thousand = number / 1000
			let million = number / 1000000
			if (million >= 1.0) {
				return `${Math.round(million*10)/10}M`
			}
			else if (thousand >= 1.0) {
				return `${Math.round(thousand*10)/10}K`
			}
			else {
				return `${number}`
			}
		},
		visibilityChanged (isVisible, entry) {
			if (isVisible) {
				let img = entry.target
				img.src = img.dataset.url
			}
		}
	}
};
</script>

<style lang="scss" scoped>
@import "../styles/components/manga-collection.scss";
</style>
